import {
  Component,
  ElementRef,
  ViewChild,
  inject,
  OnInit
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FleetsService } from '../../_services/fleets.service';
import { Constants } from '../../helpers/constants';
import { LoginHelper } from '../../helpers';
import { FleetDashboardWidget, FleetBage } from '../../_models/fleet.models';
import { Router } from '@angular/router';

@Component({
  selector: 'fleetsDashboard',
  standalone: false,
  templateUrl: './fleets.dashboard.component.html',
  styleUrls: ['./fleets.dashboard.component.scss']
})

export class FleetsDashboardComponent implements OnInit {
  api: string;
  token: string;
  widgets: FleetDashboardWidget[];

  ngOnInit(): void {
    this.fleetsService.getDashboard().subscribe({
      next: widgets => {
        this.widgets = widgets;
      }
    });
  }

  constructor(
    public fleetsService: FleetsService,
    private router: Router
  ) {
    this.api = window.location.origin || Constants.DefaultApiHost;
    this.token = LoginHelper.getFileToken();
  }

  navigateToFleetDetails(fleetId: number): void {
    this.router.navigate(
      ['/fleet-home', fleetId]);
  }

  getImageUrl(fileName: string): string {
    if (!fileName || fileName == "") {
      return `data:image/svg+xml;utf8,
        <svg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'>
          <rect width='160' height='160' rx='18' fill='%23f3f4f6' />

          <rect x='45' y='50' width='70' height='60' rx='12' fill='%236366f1' />
          <circle cx='65' cy='75' r='8' fill='white' />
          <circle cx='95' cy='75' r='8' fill='white' />
          <rect x='65' y='92' width='30' height='6' rx='3' fill='white' />

          <line x1='80' y1='50' x2='80' y2='32' stroke='%23374151' stroke-width='5' />
          <circle cx='80' cy='28' r='7' fill='%23ef4444' />

          <rect x='28' y='68' width='14' height='32' rx='7' fill='%236366f1' />
          <rect x='118' y='68' width='14' height='32' rx='7' fill='%236366f1' />

          <rect x='58' y='112' width='12' height='22' rx='6' fill='%23374151' />
          <rect x='90' y='112' width='12' height='22' rx='6' fill='%23374151' />
        </svg>`;
    }
    return `${this.api}/api/attachments/file?name=${encodeURIComponent(fileName)}&asImage=true&path=Account/Fleets&token=${this.token}`;
  }
}
